module.exports = __webpack_public_path__ + "static/img/living-at-usc-housing.93070b9.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/living-at-usc-housing.jpg
// module id = TyX8
// module chunks = 1